import React, { useEffect, useState } from 'react';
import TestimonialCarousel from '../CommonComponents/TestimonialCarousel';
import WhyChooseUs from '../CommonComponents/WhyChooseUs';
import { 
  RotatingLines 
} from 'react-loader-spinner';
import axios from 'axios';
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';

const Home = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState(null);
    const [trackingData, setTrackingData] = useState({
      gclid: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
    });
    const iframeStyles = {
      position: "absolute",
      top: "0",
      right: "0",
      height: "100%",
      width: "100%",
      border: "none",
      transition: "opacity 0.5s ease-in-out",
      opacity: loading ? 0 : 1 
    };
    
    useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
  
      const gclid = queryParams.get('gclid');
      const utm_source = queryParams.get('utm_source');
      const utm_medium = queryParams.get('utm_medium');
      const utm_campaign = queryParams.get('utm_campaign');
      const utm_term = queryParams.get('utm_term');
  
      setTrackingData({
        gclid: gclid,
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmTerm: utm_term
      });
  
      if(gclid){
        axios.post('https://api.cloudmingle.site/api/Hotel',{
          gclid: gclid,
          utmSource: utm_source,
          utmMedium: utm_medium,
          utmCampaign: utm_campaign,
          utmTerm: utm_term
        })
        .then(response => {
          setData(response.data);
          setLoading(false); 
          setError(response.status===207);
    
        })
        .catch(error => {
          console.error('API çağrısı sırasında bir hata oluştu:', error);
          setLoading(false); 
        });
      } else {
        setLoading(false);
      }
    }, []);
  
    if (loading) 
      return (
        <div style={{ 
          margin: "0px", 
          padding: "0px", 
          height: "100vh", 
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: 'hidden',
          backgroundColor: "#f5f5f5" // İsteğe bağlı arka plan rengi
        }}>
         
          <RotatingLines
            strokeColor="#4fa94d"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
          />
         
        </div>
      );
    
    if (error)
      return (
        <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
          <RotatingLines
            height={80}
            width={80}
            color="#4fa94d"
            wrapperStyle={{ 
              position: "absolute", 
              top: "50%", 
              left: "50%", 
              transform: "translate(-50%, -50%)" 
            }}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
          <iframe style={iframeStyles} src={data} title="Full Page iFrame"></iframe>
        </div>
      );
      
  return (
    <>
      <Header />
      <section className="section hero">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12">
              <h1 className="top-heading">
                <span>Explore with</span> cloudmingle: <br />
                Your Essential Guide to the <span>Best Hotels in New Zealand</span>
              </h1>
              <p className="lead">
                Are you looking for the <strong>best</strong> hotels in New Zealand? Your search
                ends here! At <span>cloudmingle</span>, we provide an expertly curated selection of
                <strong>top-rated</strong> hotels, catering to all tastes and budgets. From luxurious
                resorts to charming boutique hotels, eco-friendly accommodations, and thrilling casino hotel
                experiences, our <strong>selected</strong> options are tailored to your needs. With
                insightful reviews and reliable recommendations, we guide you to the <strong>best</strong>
                places to stay for your next getaway. Start your adventure now with our <strong>top
                picks</strong> and expert booking advice!
              </p>
            </div>
          </div>
        </div>
      </section>

      <TestimonialCarousel />

      <WhyChooseUs />
      <Footer />
    </>
  );
};

export default Home;